import { render, staticRenderFns } from "./HeaderWidget.vue?vue&type=template&id=508eafce"
import script from "./HeaderWidget.vue?vue&type=script&lang=js"
export * from "./HeaderWidget.vue?vue&type=script&lang=js"
import style0 from "./HeaderWidget.vue?vue&type=style&index=0&id=508eafce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports